<template>
  <group-form
    :group="group"
    formAction="/admin/venue-groups"
    @submitSuccess="onSubmitSuccess">
    <template #buttons>
      <ez-button form-type="submit">
        Save Changes
      </ez-button>
    </template>
  </group-form>
</template>

<script>
import { mapActions } from 'vuex';
import EzButton from '@/components/ui/Button';
import GroupForm from '@/views/common/venue-groups/Form.vue';
import Group from '@/models/Group';
import flash from '@/components/ui/FlashMessage';

export default {
  components: {
    EzButton,
    GroupForm,
  },
  props: {
    groupId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    group() {
      return Group.find(this.groupId) || {};
    },
  },
  methods: {
    onSubmitSuccess({ data }) {
      Group.update({ data: data.data });
      flash.success({
        title: `${this.$helpers.remapNaming('venue')} group successfully updated!`,
      });
    },
    ...mapActions('entities/groups', [
      'fetchGroup',
    ]),
  },
  mounted() {
    this.fetchGroup(this.groupId);
  },
};
</script>

<style scoped lang="scss">
.ez-form {
  max-width: 26rem;
  .button {
    margin-top: 1.5rem;
  }
}
</style>
